import { FilterColumnInterface } from "@/interface/app/filter.interface";
import { FilterColumnType } from "@/types/app/filter.type";

export class FilterColumn implements FilterColumnInterface {
  text: string;
  align: string;
  sortable: boolean = true;
  value: string;
  width: string;
  class: string;
  edge: string;
  selected: boolean = true;
  unRemovable?: boolean = false;
  advancedFilter: any = null;

  constructor(data: FilterColumnType) {
    this.text = data.text || "";
    this.align = data.align || "start";
    this.sortable = data.sortable;
    this.value = data.value || "";
    this.width = data.width || "1%";
    this.class = data.class || "";
    this.edge = data.edge || "";
    this.selected = true;
    this.unRemovable = data?.unRemovable || !data.text;
    this.advancedFilter = data?.advancedFilter;
  }
}
